import { render, staticRenderFns } from "./Expert2AutoEdit.vue?vue&type=template&id=7158a4af&scoped=true&"
import script from "./Expert2AutoEdit.vue?vue&type=script&lang=js&"
export * from "./Expert2AutoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7158a4af",
  null
  
)

export default component.exports